"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessages = void 0;
exports.defaultMessages = {
    locale: "Locale",
    search: "Search",
    search_bar: "Search",
    sign_in: "Sign In",
    sign_out: "Sign Out",
    default_username: "Account",
    default_download: "Get Epic Games",
    propLogoLabel: "Logo home button",
    accountMenuLabel: "Account menu",
    loading: "Loading",
};
//# sourceMappingURL=defaultMessages.js.map